import React, { useState } from 'react';
import { BarChart2, TrendingUp, Briefcase, DollarSign } from 'lucide-react';
import ARAgingReport from './ARAgingReport';
import SalesPipelineDashboard from './SalesPipelineDashboard';
import EstimateConversionReport from './EstimateConversionReport';
import OutstandingWorkReport from './OutstandingWorkReport';

const ReportsMenu = () => {
  const [selectedReport, setSelectedReport] = useState(null);

  const reports = [
    {
      id: 'pipeline',
      title: 'Sales Pipeline Dashboard',
      description: 'Business health overview with key metrics',
      icon: BarChart2,
      color: 'bg-blue-500',
      component: SalesPipelineDashboard
    },
    {
      id: 'ar-aging',
      title: 'A/R Aging Report',
      description: 'Outstanding invoices by aging bucket',
      icon: DollarSign,
      color: 'bg-green-500',
      component: ARAgingReport
    },
    {
      id: 'conversion',
      title: 'Estimate Conversion Report',
      description: 'Track estimate win rates and trends',
      icon: TrendingUp,
      color: 'bg-purple-500',
      component: EstimateConversionReport
    },
    {
      id: 'outstanding-work',
      title: 'Outstanding Work Report',
      description: 'Active jobs and workload status',
      icon: Briefcase,
      color: 'bg-orange-500',
      component: OutstandingWorkReport
    }
  ];

  if (selectedReport) {
    const report = reports.find(r => r.id === selectedReport);
    const ReportComponent = report.component;

    return (
      <div>
        <div className="no-print mb-6">
          <button
            onClick={() => setSelectedReport(null)}
            className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg"
          >
            ← Back to Reports Menu
          </button>
        </div>
        <ReportComponent />
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 flex items-center gap-2">
          <BarChart2 size={32} />
          Reports & Analytics
        </h1>
        <p className="text-gray-600 mt-2">Select a report to view detailed analytics</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {reports.map((report) => {
          const IconComponent = report.icon;
          return (
            <div
              key={report.id}
              onClick={() => setSelectedReport(report.id)}
              className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow cursor-pointer border border-gray-200 overflow-hidden"
            >
              <div className="p-6">
                <div className="flex items-start gap-4">
                  <div className={`${report.color} p-3 rounded-lg`}>
                    <IconComponent className="text-white" size={32} />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      {report.title}
                    </h3>
                    <p className="text-gray-600">
                      {report.description}
                    </p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-6 py-3 border-t border-gray-200">
                <span className="text-sm font-medium text-blue-600 hover:text-blue-700">
                  View Report →
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ReportsMenu;
